import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-mine_arrow_top",
  "use": "icon-mine_arrow_top-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-mine_arrow_top\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 0h22v22H0z\" /><path fill=\"#666\" d=\"m11 9.926-4.537 4.537-1.297-1.296L11 7.333l5.834 5.834-1.296 1.296z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol